import React from 'react';
import { Box, Card, Grid } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';

import CardActionArea from './partials/CardActionArea';
import CardContent from './partials/CardContent';
import CardMedia from './partials/CardMedia';

interface PostCardSkeletonProps {
  noMedia?: boolean;
}

function PostCardSkeleton({ noMedia }: PostCardSkeletonProps) {
  return (
    <Card sx={{ width: '100%', mb: 3 }}>
      <CardActionArea>
        {!noMedia && (
          <CardMedia>
            <Skeleton animation="wave" variant="rectangular" />
          </CardMedia>
        )}

        <CardContent>
          <Box sx={{ mb: 2 }}>
            <Skeleton animation="wave" height={30} />
            <Skeleton animation="wave" height={30} width="80%" />
          </Box>

          <Box sx={{ mb: 4 }}>
            <Skeleton animation="wave" width="50%" />
          </Box>

          <Grid container spacing={2}>
            {[0, 1, 2].map((i) => (
              <Grid key={i} item>
                <Skeleton animation="wave" variant="circular" height={30} width={30} />
              </Grid>
            ))}
          </Grid>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}

export default PostCardSkeleton;
